/* KHUN CLUB · JS mínimo, sin frameworks. Todo funciona sin JS; esto solo mejora. */

// Ticker: botón para pausar o seguir (WCAG 2.2.2: el movimiento se puede detener)
document.querySelectorAll('[data-kc-ticker]').forEach((ticker) => {
  const boton = ticker.querySelector('[data-kc-ticker-toggle]');
  if (!boton) return;
  boton.hidden = false;
  boton.addEventListener('click', () => {
    const pausado = ticker.classList.toggle('is-paused');
    boton.setAttribute('aria-pressed', String(pausado));
    boton.textContent = pausado ? 'Seguir' : 'Pausar';
  });
});

// Menú móvil (<details>): Escape lo cierra y devuelve el foco al botón
document.querySelectorAll('[data-kc-menu]').forEach((menu) => {
  const resumen = menu.querySelector('summary');
  menu.addEventListener('keydown', (evento) => {
    if (evento.key !== 'Escape' || !menu.open) return;
    menu.open = false;
    resumen.focus();
  });
  resumen.addEventListener('click', () => {
    resumen.setAttribute('aria-expanded', String(!menu.open));
  });
});

// Tráiler de YouTube: al hacer clic se cambia la miniatura por el reproductor (modo nocookie)
document.addEventListener('click', (evento) => {
  const enlace = evento.target.closest('[data-kc-youtube]');
  if (!enlace || evento.metaKey || evento.ctrlKey || evento.shiftKey) return;
  const id = enlace.dataset.kcYoutube;
  if (!/^[\w-]{11}$/.test(id)) return;
  evento.preventDefault();
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
  iframe.title = enlace.dataset.kcYoutubeTitulo || 'Video de YouTube';
  iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
  iframe.allowFullscreen = true;
  const caja = document.createElement('div');
  caja.className = 'kc-video__caja';
  caja.append(iframe);
  enlace.replaceWith(caja);
  iframe.focus();
});

// Cuenta regresiva al próximo evento (fecha ISO con zona horaria del evento).
// Con prefers-reduced-motion se actualiza cada minuto y sin segundos.
document.querySelectorAll('[data-kc-cuenta]').forEach((caja) => {
  const meta = Date.parse(caja.dataset.kcCuenta);
  if (Number.isNaN(meta)) return;
  const quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pon = (sel, n) => { const e = caja.querySelector(sel); if (e) e.textContent = String(n).padStart(2, '0'); };
  const texto = caja.querySelector('[data-kc-cuenta-texto]');
  const pintar = () => {
    const faltan = Math.max(0, meta - Date.now());
    const s = Math.floor(faltan / 1000);
    pon('[data-kc-cuenta-dias]', Math.floor(s / 86400));
    pon('[data-kc-cuenta-horas]', Math.floor((s % 86400) / 3600));
    pon('[data-kc-cuenta-min]', Math.floor((s % 3600) / 60));
    pon('[data-kc-cuenta-seg]', quieto ? '--' : s % 60);
    return s;
  };
  const s = pintar();
  if (texto) texto.textContent = `Faltan ${Math.floor(s / 86400)} días.`;
  setInterval(pintar, quieto ? 60000 : 1000);
});
